"use client";

import { Typography } from "@mui/material"
import { User } from "@/api/users";

interface UserListProps {
    users: User[]
}

export function UserList({ users }: UserListProps) {
    return (
        <Typography variant="body2" color="text.secondary">
            {users.map(user => user.email).join(', ')}
        </Typography>
    );
}
